<template>
  <iframe :src="serviceUrl" frameborder="0" class="full-screen-iframe"></iframe>
</template>

<script>
import { getIMEI } from "@/utils/IMEI";
import { queryEmailCallback } from '@/apis/common';
export default {
  data() {
    return {
      serviceUrl: '',
    }
  },
  created() {
    // 邮件模版点击
    const jobid = this.$route.query.jobid;
    const email = this.$route.query.email;
    if (jobid && email) {
      queryEmailCallback({
        b: jobid,
        e: email,
        t: 0,
        r: '内部错误',
        u: window.location.href.split('?')[0],
        s: ''
      }).then(() => {
      })
    }
    this.$router.replace({
      path: this.$route.path,
      // 或者 name: 'YourRouteName',
      query: {} // 清空 query
    });
    const screenWidth = document.body.clientWidth;
    const account = getIMEI();
    this.serviceUrl = 'https://care80.live800.com/chat/chatClient/chatbox.jsp?companyID=80028755&configID=1084'
  },
}
</script>

<style scoped>
.full-screen-iframe {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  border: none; /* 可选，进一步去除边框 */
  z-index: 0; /* 根据需要调整 */
}
</style>